import { render, staticRenderFns } from "./ReconciliationStat.vue?vue&type=template&id=18867400&scoped=true"
import script from "./ReconciliationStat.vue?vue&type=script&lang=js"
export * from "./ReconciliationStat.vue?vue&type=script&lang=js"
import style0 from "./ReconciliationStat.vue?vue&type=style&index=0&id=18867400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18867400",
  null
  
)

export default component.exports